import { render, staticRenderFns } from "./RoutesImportTemplateModal.vue?vue&type=template&id=60c39f30&scoped=true&"
import script from "./RoutesImportTemplateModal.vue?vue&type=script&lang=js&"
export * from "./RoutesImportTemplateModal.vue?vue&type=script&lang=js&"
import style0 from "./RoutesImportTemplateModal.vue?vue&type=style&index=0&id=60c39f30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c39f30",
  null
  
)

export default component.exports